import { render, staticRenderFns } from "./OpenApiManager.vue?vue&type=template&id=56dd432a&scoped=true"
import script from "./OpenApiManager.vue?vue&type=script&lang=ts"
export * from "./OpenApiManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dd432a",
  null
  
)

export default component.exports